import React from "react";
import { makeStyles } from "tss-react/mui";
import { MiStackedTypography } from "@miplatform/components";
import { DATE_TIME_FORMATS } from "@miplatform/constants";
import { IInspectionAttempt } from "@miplatform/types";
import { getFormattedDate } from "@miplatform/utils";
import { Divider } from "@mui/material";
import { Box } from "@mui/system";

export const InspectionDetailsCard = ({
  inspectionAttempt,
  attemptNumber,
}: {
  inspectionAttempt: IInspectionAttempt;
  attemptNumber?: number;
}) => {
  const { classes } = useStyles();

  const detailFields = [
    { title: "Status", description: inspectionAttempt.attemptStatus },
    {
      title: "Sched. Date",
      description: getFormattedDate(
        DATE_TIME_FORMATS.FORMAT_M_D_YY,
        inspectionAttempt.approvedStartDate
      ),
    },
    {
      title: "Attempt Number",
      description: `Attempt ${attemptNumber ?? 1}`,
    },
  ];

  return (
    <Box className={classes.inspectionDetailsCard}>
      {detailFields.map((field, i) => (
        <React.Fragment key={field.title}>
          {i > 0 && (
            <Divider
              orientation="vertical"
              flexItem
              className={classes.divider}
            />
          )}
          <MiStackedTypography
            key={field.title}
            title={field.title}
            titleFontSize={11}
            description={field.description ?? "N/A"}
            descriptionFontSize={12}
            descriptionProps={{ style: { fontWeight: 600 } }}
          />
        </React.Fragment>
      ))}
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  inspectionDetailsCard: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 2),
  },
  scheduleSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  scheduleSectionField: {
    flex: 1,
  },
  divider: {
    height: 26,
    alignSelf: "center",
    margin: theme.spacing(0, 2),
  },
}));
